<rid-morpheme-board-freeform class="h-dvh" />
